import React from "react";
import ASSETS from "../../data/assets";

const Logo = ({ size = 75 }) => (
  <img
    src={ASSETS.logo}
    alt="Fa1th Hook"
    className="block object-contain"
    style={{ width: size, height: size }}
  />
);

export default Logo;
